import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../../service/wp-blogs-store'
import { useEffect, useState } from 'react'
import { PersonalTrainerHead } from '@/index/service-category/personal-trainer/PersonalTrainerHead'
import { openModal } from 'service/modal-service'
import { TrainerCustomerReviews } from '@/index/service-category/personal-trainer/TrainerCustomerReviews'
import { Faq } from '@/commons/Faq'
import { ptSingaporeFaqs } from 'utils/faq'
import { useRouter } from 'next/router'
import { RequestProvider } from 'context/RequestContext'
import { PersonalTrainerBooking } from '@/index/service-category/personal-trainer/PersonalTrainerBooking'
import { PersonalTrainerWhyUs } from '@/index/service-category/personal-trainer/PersonalTrainerWhyUs'
import { getTestimonials } from 'api/user/profile-api'
import { DarkFaq } from '@/index/service-category/personal-trainer/DarkFaq'
import { FaCheckCircle } from 'react-icons/fa'
import TrainerValueProposition from '@/index/service-category/personal-trainer/TrainerValueProposition'
import { localBusinessNode, buildServiceNode } from 'utils/local-business-schema'

export async function getStaticProps() {

    const { modifiedDate, month, year } = getArticleDateTime();
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const testimonials = await getTestimonials("Fitness Trainer", 0, 6)
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts,
        testimonials
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings
    const testimonials = props.testimonials
    const [ requestForm, setRequestForm ] = useState(false)

    const requestType = "Fitness Trainer"
    const [isQuickBook, setIsQuickBook] = useState(false)
    const [isCustomBook, setIsCustomBook] = useState(false)

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
    }

    useEffect(() => {
        if(router.query.requestForm === "true"){
            setRequestForm(true)
            openModal(setRequestForm)
        }
    }, [router.query.requestForm])

  return (
    <>
      <Head>
        <title>Private Home Trainer in Singapore | Personal Training at Home</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Experience personalized personal training at home in Singapore. Certified private home trainers come to your doorstep with flexible scheduling and custom workout plans. Book now for convenient in-home fitness."/>
        <meta name="keywords" content="private home trainer Singapore, personal training at home, in-home personal trainer, home gym session"/>
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/personal-trainer/private-home-trainer" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Private Home Trainer in Singapore | Personal Training at Home`}/>
        <meta property="og:description" content="Experience personalized personal training at home in Singapore. Certified private home trainers come to your doorstep with flexible scheduling and custom workout plans." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-06T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/girls-personal-training.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/girls-personal-training.jpg" />
        <meta name="twitter:site" content="@stringssg"/>
        <meta name="twitter:url" content="https://www.stringssg.com/sg/personal-trainer/private-home-trainer"/>
        <meta name="twitter:title" content={`Private Home Trainer in Singapore | Personal Training at Home`}/>
        <meta name="twitter:description" content="Experience personalized personal training at home in Singapore. Certified private home trainers come to your doorstep with flexible scheduling and custom workout plans."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/private-home-trainer" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@type":"BreadcrumbList","@id":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/#breadcrumblist","itemListElement":[{"@type":"ListItem","@id":"https://www.stringssg.com/#listItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"},"nextItem":"https://www.stringssg.com/sg/personal-trainer/#listItem"},{"@type":"ListItem","@id":"https://www.stringssg.com/sg/personal-trainer/#listItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/","name":"personal-trainer","url":"https://www.stringssg.com/sg/personal-trainer/"},"previousItem":"https://www.stringssg.com/#listItem","nextItem":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/#listItem"},{"@type":"ListItem","@id":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/#listItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/","name":"private-home-trainer","description":"Private home trainer in Singapore offering personalized personal training at home with flexible scheduling and custom workout plans.","url":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/"},"previousItem":"https://www.stringssg.com/sg/personal-trainer/#listItem"}]},${JSON.stringify(localBusinessNode)},${JSON.stringify(buildServiceNode({ pageUrl: "https://www.stringssg.com/sg/personal-trainer/private-home-trainer", name: "Private Home Personal Trainer Singapore", serviceType: "Personal Training", priceRange: "S$84.00 - S$110.00", image: "https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/girls-personal-training.jpg" }))},{"@type":"Product","url":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer","name":"StringsSG Private Home Training","image":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/girls-personal-training.jpg","brand":{"@id":"https://www.stringssg.com/#organization"}},{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG Singapore","url":"https://www.stringssg.com/"},{"@type":"VideoObject","@id":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/#video","name":"Private Home Trainer in Singapore ${year}","description":"Experience personal training at home with StringsSG certified trainers. Convenient, personalized fitness sessions delivered to your doorstep.","thumbnailUrl":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/fitness-package5.jpg","https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/fitness-package6.jpg"],"uploadDate":"2025-01-03T08:00:00+08:00","duration":"PT0M16S","contentUrl":"https://youtu.be/CC4Pe6-I1PY","embedUrl":"https://www.youtube.com/embed/CC4Pe6-I1PY","interactionStatistic":{"@type":"InteractionCounter","interactionType":{"@type":"WatchAction"},"userInteractionCount":5647018}},{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/#webpage","url":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/","name":"Private Home Trainer in Singapore ${year}","description":"Private home trainer in Singapore offering personalized personal training at home with flexible scheduling and custom workout plans.","inLanguage":"en-US","isPartOf":{"@id":"https://www.stringssg.com/#website"},"breadcrumb":{"@id":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/#breadcrumblist"},"video":{"@id":"https://www.stringssg.com/sg/personal-trainer/private-home-trainer/#video"},"datePublished":"2025-01-06T07:30:46+00:00","dateModified":"${modifiedDate}"}]}`
          }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/private-home-trainer" />
        </Head>
        <div>
            <RequestProvider>
                <PersonalTrainerHead
                    heroImage={s3Static + "blog/health+and+fitness/girls-personal-training.jpg"}
                    title={`Private Home Trainer Singapore (${year})`}
                    heading={`Private Home Trainer Singapore (${year})`}
                    heroCopy="Your trainer comes to you, from $84/session. No commute, no gym membership - just coaching in your own space."
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    isCustomBook={isCustomBook}
                    requestType={requestType}
                    requestCategorySettings={requestCategorySettings}
                />
            </RequestProvider>
            <section className="mx-auto py-6 px-2 bg-slate-900 relative">
                {/* Mesh gradient */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/15 rounded-full blur-3xl" />
                <div className="absolute bottom-0 left-0 w-80 h-80 bg-amber-400/10 rounded-full blur-3xl" />
                {/* <h2 className='text-2xl md:text-4xl text-center text-white font-extrabold tracking-tight py-5'>
                    <strong>Private Home Trainer in Singapore</strong>
                </h2> */}
                <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center py-6 relative">                    
                    <div className="text-white/70 space-y-5 leading-8 text-lg">
                        <p>
                            Experience the convenience of personal training at your own home in Singapore. Our certified private home trainers bring professional fitness sessions directly to your doorstep, eliminating gym commutes and offering fully personalized workout plans in the comfort of your space.
                        </p>
                        <p>
                            With flexible scheduling from early morning to late evening, our in-home personal trainers ensure you get consistent, effective training that fits seamlessly into your busy Singapore lifestyle.
                        </p>
                    </div>
                    {/* Image Section */}
                    <div className="relative h-62.5 lg:h-87.5">
                        {/* Floating badge - Certified */}
                        <div className="absolute top-4 right-4 z-10 bg-white/10 backdrop-blur-md rounded-2xl px-4 py-3 shadow-xl border border-white/20">
                            <div className="flex items-center gap-2">
                                <div className="w-10 h-10 bg-linear-to-br from-green-400 to-emerald-500 rounded-xl flex items-center justify-center">
                                    <FaCheckCircle className="text-white" />
                                </div>
                                <div>
                                    <p className="text-xs text-white/50">Certified</p>
                                    <p className="font-bold text-white/90">Trainers</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="relative w-full h-full rounded-3xl overflow-hidden shadow-2xl">
                            <Image
                                src={s3Static + "personal-trainer/personal-trainer-png.png"}
                                fill
                                style={{ objectFit: 'contain', objectPosition: 'top' }}
                                alt="Personal Trainer Singapore - StringsSG"
                                sizes="(max-width: 768px) 100vw, 50vw"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <TrainerValueProposition/>
            <RequestProvider>
                <PersonalTrainerBooking
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    year={year}
                />
            </RequestProvider>

            <section className="py-6 px-4 space-y-4 leading-relaxed bg-slate-900">
                <div className='max-w-5xl mx-auto space-y-5'>
                    <h2 className="text-2xl font-extrabold text-white">Why Choose Personal Training at Home in Singapore?</h2>
                    <p className='text-white/60'>
                        Private home training offers numerous advantages for busy Singapore residents who want professional fitness guidance without the constraints of traditional gym visits. Whether you&apos;re living in a condominium, HDB flat, or landed property, our certified trainers adapt workouts to your available space and equipment.
                    </p>
                    <p className='text-white/60'>
                        The convenience factor cannot be overstated - no more rushing to beat traffic jams during peak hours, no membership fees, and the ability to train in comfortable, familiar surroundings that reduce workout intimidation.
                    </p>
                    <p className='text-white/60'>
                        Home and condo gym sessions typically run $100 to $140 each, above a public gym session but below a commercial gym trainer once membership is
                        counted. See{' '}
                        <Link href="/sg/personal-trainer/personal-trainer-rates-singapore" prefetch={false} className="text-orange-400/90 hover:text-orange-400 underline">
                            what personal trainers charge per session in Singapore
                        </Link>{' '}
                        for the full breakdown by training location.
                    </p>
                </div>
            </section>

            <section className="px-4 space-y-6 bg-slate-900 py-10 relative overflow-hidden">
                {/* Mesh gradient blobs */}
                <div className="absolute top-0 right-0 w-72 h-72 bg-blue-500/30 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3" />
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-violet-500/20 rounded-full blur-3xl -translate-x-1/4 translate-y-1/4" />
                <div className="absolute top-1/2 right-1/4 w-40 h-40 bg-cyan-400/15 rounded-full blur-2xl" />
                <h2 className="text-2xl font-extrabold text-center text-white">Benefits of Private Home Personal Training</h2>
                <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 py-5">
                    <article className="space-y-3">
                        <h3 className="text-lg font-semibold text-blue-500">1. Maximum Convenience</h3>
                        <p className='text-white/60'>Skip gym commutes entirely. Our trainers arrive at your doorstep in all major Singapore districts including Orchard, Marina Bay, Tampines, Jurong, Woodlands, and more.</p>
                    </article>
                    <article className="space-y-3">
                        <h3 className="text-lg font-semibold text-green-500">2. Fully Personalized Experience</h3>
                        <p className='text-white/60'>Workouts are designed specifically for your home environment, taking into account available space, equipment, and your specific fitness goals.</p>
                    </article>
                    <article className="space-y-3">
                        <h3 className="text-lg font-semibold text-purple-500">3. Flexible Session Times</h3>
                        <p className='text-white/60'>From early morning sessions before work to evening workouts after dinner, choose times that perfectly fit your Singapore work schedule.</p>
                    </article>
                    <article className="space-y-3">
                        <h3 className="text-lg font-semibold text-orange-500">4. Private & Comfortable</h3>
                        <p className='text-white/60'>Train in complete privacy without the intimidation of public gym environments. Focus entirely on your progress in a stress-free setting.</p>
                    </article>
                    <article className="space-y-3">
                        <h3 className="text-lg font-semibold text-red-500">5. No Equipment Required</h3>
                        <p className='text-white/60'>Many sessions can be conducted with minimal equipment. Our trainers bring along resistance bands, kettlebells, and other portable gear.</p>
                    </article>
                    <article className="space-y-3">
                        <h3 className="text-lg font-semibold text-indigo-500">6. Consistent Accountability</h3>
                        <p className='text-white/60'>Regular home visits ensure you stay committed to your fitness journey. Our trainers provide ongoing motivation and progress tracking.</p>
                    </article>
                </div>
            </section>

            <section className="px-4 space-y-6 bg-slate-900 py-10">
                <h2 className="text-2xl font-extrabold text-white text-center">How Home Personal Training Works in Singapore</h2>
                <div className="max-w-6xl mx-auto space-y-10">
                    <div className="flex items-start space-x-4">
                        <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">1</div>
                        <div className='space-y-3'>
                            <h3 className="font-semibold text-white">Initial Assessment</h3>
                            <p className='text-white/60'>Your trainer conducts a comprehensive fitness assessment, discussing your goals, medical history, and available equipment at home.</p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-4">
                        <div className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">2</div>
                        <div className='space-y-3'>
                            <h3 className="font-semibold text-white">Customized Program Design</h3>
                            <p className='text-white/60'>Based on your assessment, a personalized workout plan is created that matches your fitness level and home environment.</p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-4">
                        <div className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">3</div>
                        <div className='space-y-3'>
                            <h3 className="font-semibold text-white">Regular In-Home Sessions</h3>
                            <p className='text-white/60'>Your certified trainer visits your Singapore home for 60-minute sessions according to your booked schedule.</p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-4">
                        <div className="bg-orange-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">4</div>
                        <div className='space-y-3'>
                            <h3 className="font-semibold text-white">Progress Tracking & Adjustments</h3>
                            <p className='text-white/60'>Sessions include progress monitoring with regular program adjustments to ensure continued improvement.</p>
                        </div>
                    </div>
                </div>
            </section>
            <PersonalTrainerWhyUs/>
            <TrainerCustomerReviews testimonials={testimonials}/>

            <section className="relative py-8 md:py-12 overflow-hidden bg-slate-900">
                <div className="absolute top-0 left-0 w-72 h-72 bg-orange-500/8 rounded-full blur-3xl" />
                <div className='relative z-10 max-w-5xl mx-auto px-4'>
                    <DarkFaq 
                        title="Personal Training FAQs"
                        questionsAnswers={ptSingaporeFaqs} 
                    />
                </div>
            </section>

            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts} theme="dark"/>
        </div>
        <Script
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-QD1HGGHDYJ');
          }}
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
